import { Button, Dialog, DialogActions, DialogContent, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import alertService from "../../services/alertService";

const AlertModal = () => {

	let [ message, setMessage ] = useState(false);
	
	useEffect(() => {
		alertService.onAlert = handleAlert;
	}, []);
	
	const handleAlert = (message) => {
		setMessage(message);
	};
	
	const handleClose = () => {
		setMessage(false);
	};
	
	return (
		<Dialog
			open={message}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogContent>
				<Box sx={{ textAlign: "center", marginTop: "1em", marginBottom: "1em" }}>
					{message}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>OK</Button>
			</DialogActions>
		</Dialog>
	);

}

export default AlertModal;